var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@gerdau/hefesto';
import './Tag.styles.scss';
var Tag = function (_a) {
    var children = _a.children, tooltipTitle = _a.tooltipTitle, tooltipTitlePlacement = _a.tooltipTitlePlacement, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    return (_jsx("div", __assign({ className: "hefesto-tag hefesto-tag--".concat(variant), "data-testid": "tag-component" }, { children: tooltipTitle ? (_jsx(Tooltip, __assign({ title: tooltipTitle, placement: tooltipTitlePlacement }, { children: _jsx("span", __assign({ "aria-label": "label title" }, { children: children })) }))) : (_jsx("span", __assign({ "aria-label": "label title" }, { children: children }))) })));
};
export default Tag;
